import { createSlice } from "@reduxjs/toolkit";
import { addInterviewCommentThunk, getInterviewCommentsThunk } from "../thunks/InterviewThunk";

const initialState = {
    _id: null,
    comments: [],
    loading: false,
    error: null,
    isAdminLoggedIn: true, // Default to true; update based on your auth logic
};



export const interviewCommentsSlice = createSlice({
    name: "interviewCommentsSlice",
    initialState,
    reducers: {
        setInterviewComments: (state, action) => {
            state._id = action.payload._id;
            state.comments = action.payload.comments;
        },
        setIsAdminLoggedIn: (state, action) => {
            state.isAdminLoggedIn = action.payload;
        },
        resetInterviewCommentsState: (state) => {
            state._id = null;
            state.comments = [];
            state.loading = false;
            state.error = null;
        },

    },
    extraReducers: (builder) => {
        // You can handle async thunks here if needed
        builder.addCase(getInterviewCommentsThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
            // Clear previous candidate's comments so a slow/failed fetch can't
            // leak the last-viewed candidate's remarks into another candidate.
            state.comments = [];
        });
        builder.addCase(getInterviewCommentsThunk.fulfilled, (state, action) => {
            state._id = action.payload._id;
            state.comments = action.payload.comments;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getInterviewCommentsThunk.rejected, (state, action) => {
            state.loading = false;
            // Optionally handle errors
            state.error = action.payload;
            state.comments = [];
            console.error("Failed to fetch interview comments:", action.payload);
        });

        builder.addCase(addInterviewCommentThunk.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.comments.push(action.payload);
        });
        builder.addCase(addInterviewCommentThunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            console.error("Failed to add interview comment:", action.payload);
        });
        builder.addCase(addInterviewCommentThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
    }
});



export const { setInterviewComments , setIsAdminLoggedIn ,resetInterviewCommentsState} = interviewCommentsSlice.actions;
export default interviewCommentsSlice.reducer;